import { Box, Typography } from '@mui/material';

const ERPPage: React.FC = () => {
    return (
        <Box sx={{ backgroundColor: 'red', width: 300, height: 500 }}>
            <Typography>ERP Page</Typography>
        </Box>
    );
};
export default ERPPage;
